export default import.meta.ROLLUP_FILE_URL_OestAvA2SyLT4CG6L76dAw;